import i18next, { type InitOptions, type Resource, type ThirdPartyModule } from 'i18next';
import ICU from 'i18next-icu';

export const LOCALES = ['en', 'ms'] as const;
export type AppLocale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: AppLocale = 'en';

export type AppResources = Record<AppLocale, Resource[string]>;

export function isAppLocale(value: unknown): value is AppLocale {
  return LOCALES.includes(value as AppLocale);
}

// Message types come from each app's `declare module 'i18next'`, so `t()` only accepts that app's keys.
export function createI18n(
  lng: AppLocale,
  resources: AppResources,
  { modules = [], ...options }: InitOptions & { modules?: ThirdPartyModule[] } = {}
) {
  const instance = i18next.createInstance().use(new ICU());
  for (const m of modules) instance.use(m);
  instance.init({
    lng,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALES,
    resources,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    initAsync: false,
    ...options,
  });
  return instance;
}
